var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEWaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.856933 1.34615L0.856934 10.6538C0.856934 11.1212 1.20871 11.5 1.64265 11.5L6.35693 11.5C6.79087 11.5 7.14265 11.1212 7.14265 10.6538L7.14265 1.34615C7.14265 0.878836 6.79087 0.5 6.35693 0.5L1.64265 0.500001C1.20871 0.500001 0.856933 0.878837 0.856933 1.34615Z",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99993 9.14287C3.56599 9.14287 3.21422 9.49464 3.21422 9.92858C3.21422 10.3625 3.56599 10.7143 3.99993 10.7143C4.43387 10.7143 4.78564 10.3625 4.78564 9.92858C4.78564 9.49464 4.43387 9.14287 3.99993 9.14287Z",
    fill: "black",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEWaste);
export default __webpack_public_path__ + "static/media/e-Waste.ae703e8b6dcf1bf748c7bdd563d1187e.svg";
export { ForwardRef as ReactComponent };